import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/UploadSku7MrpMaster';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const UploadSku7MrpMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">SKU7 MRP Master - Upload</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

UploadSku7MrpMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadSku7MrpMaster);
